/**
 * Escalones de zoom y su etiqueta — lógica pura, separada de la vista.
 *
 * Vive fuera de `parts/ZoomControl.tsx` para poder probarse sin arrastrar
 * `styles.ts`: un fichero de estilos trae consigo la ampliación del tipo del
 * tema, que solo existe dentro del build de la aplicación.
 */

/**
 * Sin deslizador, a propósito: un control continuo pegado al borde es justo lo
 * que peor se maneja con guantes de trabajo y a contraluz. Escalones grandes
 * para el uso normal, y el pellizco para el ajuste fino.
 */
export const zoomSteps = (maxFactor: number): number[] => {
  const steps = [1, 2, 4, 8].filter((s) => s <= maxFactor);
  const top = Math.round(maxFactor);
  if (top > 1 && !steps.includes(top)) steps.push(top);
  return steps;
};

/** Etiqueta corta: `1×`, `2,5×`. Sin decimales cuando el número es redondo. */
export const zoomLabel = (factor: number): string => {
  const rounded = Math.round(factor * 10) / 10;
  const text = Number.isInteger(rounded)
    ? String(rounded)
    : String(rounded).replace('.', ',');
  return `${text}×`;
};

/**
 * Escalón que hay que marcar como activo: el mayor que no supera el factor
 * actual. Sin esto, mover el pellizco deja los tres botones apagados y el
 * operario no sabe dónde está.
 */
export const activeZoomStep = (steps: number[], factor: number): number =>
  steps.reduce((acc, s) => (factor >= s - 0.01 ? s : acc), steps[0]);
